import {
  ServiceRightContainer,
  ServiceRightInnerBox,
  ServiceRightOuterBox,
} from "./ServiceRight.styles";
import ServiceRightForm from "./ServiceRightForm";
import {
  AnimatedModal,
  SendImg,
  SendMobileImg,
  ShareLinkImg,
  ShareLinkMobileImg,
} from "./ServicesAnimation.styles";
import {
  ShareLink,
  Pay,
  ShareLinkMobile,
  SendMobile,
} from "../../../../public/assets";
import { useEffect, useState } from "react";
import SuccessfulModal from "./SuccessfulModal";

const ServiceRight = () => {
  const servicesModal = [
    <ShareLinkImg src="/assets/services/shareLink.svg" />,
    <ShareLinkMobileImg src="/assets/services/shareLink-mobile.svg" />,
    <SendMobileImg src="/assets/services/sendMobile.png" />,
    <SendImg src="/assets/services/send.svg" />,
    <SuccessfulModal />,
  ];
  const [imageIndex, setImageIndex] = useState<number>(0);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);

  useEffect(() => {
    const initialIndex = 0;
    let prevIndex = initialIndex;

    const interval = setInterval(() => {
      setIsAnimating(true);
      let nextIndex = (prevIndex + 1) % servicesModal.length;

      while (nextIndex === prevIndex) {
        nextIndex = (nextIndex + 1) % servicesModal.length;
      }
      setImageIndex(nextIndex);
      prevIndex = nextIndex;
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <ServiceRightContainer>
      <ServiceRightOuterBox>
        <ServiceRightInnerBox>
          {servicesModal.map((modal, index) => (
            <AnimatedModal
              key={index}
              isVisible={index === imageIndex}
              isAnimating={isAnimating && index === imageIndex}
            >
              {modal}
            </AnimatedModal>
          ))}
          <ServiceRightForm />
        </ServiceRightInnerBox>
      </ServiceRightOuterBox>
    </ServiceRightContainer>
  );
};

export default ServiceRight;
